import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { PAGE_CHANGED } from 'actions/globalActions'
import { CC_ONBOARDING_MAX_STEPS_AUTH, CC_ONBOARDING_MAX_STEPS_UNAUTH } from 'components/features/creditCard/creditCardStore/constants'


export const ccOnboardingStepsCountReducer: Reducer<CreditCardDataState['onboardingStepsCount']> = (prevState = CC_ONBOARDING_MAX_STEPS_AUTH, action) => {
  switch (action.type) {
    case PAGE_CHANGED: {
      if (action.payload.next.indexOf('/credit-card/onboarding') === 0 && action.payload.prev?.indexOf('/card/property') === 0) {
        return CC_ONBOARDING_MAX_STEPS_UNAUTH
      }
    }
  }
  return prevState
}
